import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.analysis.widget.stability');
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-analysis-widget-stability',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.analysis.widget.stability/view.scss */
/* src/app/portal.analysis.widget.stability/view.scss: no such file or directory */`],
})
export class PortalAnalysisWidgetStabilityComponent implements OnInit, OnChanges {
    @Input() data: ResearcherData;
    @Input() years: number[];
    @Input() period: any;

    public researcher: any[];
    public products: any[];

    ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            const curr = changes['period'].currentValue;
            this.periodStart = curr?.start;
            this.periodEnd = curr?.end;
            this.loadData();
        }
    }

    constructor(@Inject( Service) private service: Service) { }

    avgCount = 0;
    datasets = [];

    chartLine: Chart | null = null;

    public async ngOnInit() {
        await this.service.init();
        this.mapping();
        this.loadData();
        await this.service.render();
    }

    public mapping() {
        this.researcher = this.data.researcher;
        this.periodEnd = this.data.period.end;
        this.periodStart = this.data.period.start;
        this.products = this.data.products;
        this.service.render();
    }

    private loadData() {
        if (!this.products || !this.years) return;

        const filtered = this.products.filter(p => {
            const year = Number(p.pub_year);
            return year >= this.periodStart && year <= this.periodEnd;
        });

        const keywordYearMap: Record<string, number[]> = {};

        for (const p of filtered) {
            const year = Number(p.pub_year);
            if (!year || !this.years.includes(year)) continue;

            let raw = p.kr_keywords?.trim() || p.en_keywords?.trim();
            if (!raw) continue;

            const parts = raw.split(";").map(x => x.trim()).filter(x => x.length > 0);

            for (const kw of parts) {
                if (!keywordYearMap[kw]) {
                    keywordYearMap[kw] = this.years.map(() => 0);
                }
                const idx = this.years.indexOf(year);
                if (idx >= 0) {
                    keywordYearMap[kw][idx] += 1;
                }
            }
        }

        this.datasets = Object.entries(keywordYearMap).map(([kw, data], i) => {
            const total = data.reduce((a, b) => a + b, 0);
            return {
                label: kw,
                data: data,
                total: total,
                borderColor: this.randomColor(i),
                backgroundColor: this.randomColor(i),
            };
        });
        this.removeIndex();
        this.datasets = (this.datasets ?? []).sort((a: any, b: any) => b.total - a.total);
        if (this.datasets.length > 0) {
            const totalAll = this.datasets.reduce((sum, ds) => sum + ds.total, 0);
            this.avgCount = Math.round(totalAll / this.years.length);
        } else {
            this.avgCount = 0;
        }

        setTimeout(() => this.renderLineChart(), 0);
    }

    public removeIndex() {
        // 1️⃣ years별로 0이 아닌 데이터가 하나라도 있는 인덱스만 남기기
        const validYearIndices: number[] = [];

        for (let i = 0; i < this.years.length; i++) {
            // 모든 dataset의 i번째 값 확인
            const hasNonZero = this.datasets.some(ds => Number(ds.data[i]) !== 0);
            if (hasNonZero) validYearIndices.push(i);
        }

        // 2️⃣ years와 각 dataset의 data를 필터링
        this.years = this.years.filter((_, i) => validYearIndices.includes(i));

        this.datasets = this.datasets.map(ds => ({
            ...ds,
            data: ds.data.filter((_: any, i: number) => validYearIndices.includes(i))
        }));

    }

    private randomColor(): string {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    private renderLineChart(): void {
        if (this.chartLine) this.chartLine.destroy();

        this.chartLine = new Chart('lineChart', {
            type: 'line',
            data: {
                labels: this.years,
                datasets: this.datasets.map(ds => ({
                    ...ds,
                    fill: false,
                    borderWidth: 2,
                    tension: 0,
                    pointRadius: 5,
                    pointHoverRadius: 6,
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 2
                }))
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        offset: false,
                        grid: { display: false },
                        ticks: { color: '#000', font: { size: 16, weight: 'bold' }, autoSkip: false }
                    },
                    y: {
                        beginAtZero: true,
                        grid: { color: '#E2E6F2' },
                        ticks: {
                            display: false,
                            stepSize: 1,
                            precision: 0
                        },
                        border: { display: false }
                    }
                },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => `${ctx.dataset.label}: ${ctx.raw}건`
                        }
                    }
                }
            }
        } as ChartConfiguration);
    }


    // private renderLineChart(): void {
    //     if (this.chartLine) this.chartLine.destroy();
    //     this.chartLine = new Chart('lineChart', {
    //         type: 'line',
    //         data: {
    //             labels: this.years,
    //             datasets: this.datasets.map(ds => ({
    //                 ...ds,
    //                 fill: false,
    //                 borderWidth: 2,
    //                 tension: 0,
    //                 pointRadius: 5,
    //                 pointHoverRadius: 6,
    //                 pointBackgroundColor: '#fff',
    //                 pointBorderWidth: 2
    //             }))
    //         },
    //         options: {
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             scales: {
    //                 x: {
    //                     offset: false,
    //                     grid: { display: false },
    //                     ticks: { color: '#000', font: { size: 16, weight: 'bold' }, autoSkip: false, }
    //                 },
    //                 y: {
    //                     beginAtZero: true,
    //                     grid: { color: '#E2E6F2' },
    //                     stepSize: 1,  
    //                     precision: 0,  
    //                     ticks: { display: false },
    //                     border: { display: false }
    //                 }
    //             },
    //             plugins: {
    //                 legend: { display: false },
    //                 tooltip: {
    //                     callbacks: {
    //                         label: (ctx) => `${ctx.dataset.label}: ${ctx.raw}건`
    //                     }
    //                 }
    //             }
    //         }
    //     } as ChartConfiguration);
    // }
}

export default PortalAnalysisWidgetStabilityComponent;